export var webInfoHzc = {
    id: 'hzc',
    webName: '惠智采',
    webFullName: '惠智采',
    iconUrl: '/favicon.ico',
    logoUrl: '/logos/hzc/logo.png', // http://www.zhbykj.com/logos/hzc/logo.png
    mobile: '400-780-9998',
    themeColor: '#8a1f94',
    citycode: "0",
    planname:'hzc',     // 平台内标识

    loginUrl: 'http://web.smartprocure.cn/login/',
    signUrl: 'http://web.smartprocure.cn/register/',

    home: {
        banner: [
            {
                text1: '1个目标',
                text2: '致力于高效采购、智慧管理，智能采购综合管理平台，轻松搞定采购',
                btn: true,
                itemBg: '/images/hzc/home/bg.png',
                textPos: { marginLeft: `-600px`, marginTop: '-170px' },
                textSize: { height: '100px' },
                animate: 'animate__flipInX',
                animateController: false,
            },
            {
                text1: '',
                text2: '',
                btn: false,
                itemBg: '/images/hzc/home/bg1.jpg',
                textPos: { marginLeft: `-600px`, marginTop: '-170px' },
                textSize: { height: '100px' },
                animate: 'animate__flipInX',
                animateController: false,
                url: 'https://biaoshu.huitoue.com/?source=smartprocure&inviteCode=093163&channelCode=110909#/web'
            },
        ],
        gxzcList: [
            {
                img: '/images/hzc/home/ea-bidding-procurement.png',
                title: '一站式电子招标采购',
                text: '支持九大采购模式，根据项目不同，灵活切换模式。',
            },
            {
                img: '/images/hzc/home/ea-manage.png',
                title: '供应商及专家智能管理',
                text: '建立优质供应商及专家库，进行全流程把控智能分级， 多种寻源方式，轻松比价定价。',
            },
            {
                img: '/images/hzc/home/ea-cooperate.png',
                title: '内外协同强势增效',
                text: '实现外部内部全角色协作，多节点流转，大幅度提升工作效率。',
            },
            {
                img: '/images/hzc/home/ea-supervise.png',
                title: '监管透明合规',
                text: '系统全程留痕，与监管平台对接，整个过程公开透明。',
            },
        ],
        zhglList: [],
        jjfaBg: '/images/hzc/home/bg-solution.png', //全场景解决方案
        ptlc: '/images/hzc/home/liangdian.png',    //平台流程
        kjfnLsit: [
            {
                title: '智能化赋能  系统随时响应',
                text: '随时修改、随时发布，在快速发展的业务中游刃有余，业务增长迫在眉睫，但系统早已准备就绪',
                img: '/images/hzc/home/tec/1.png',
            },
            {
                title: '互联网+赋能  协同更便捷',
                text: '互联网+覆盖采购全流程，协同每个角色及节点，平台快速响应业务变化',
                img: '/images/hzc/home/tec/2.png',
            },
            {
                title: '数字化赋能  精准决策',
                text: '基于大数据和算法，智能建模，精准把控采购决策，平台响应每个业务',
                img: '/images/hzc/home/tec/3.png',
            },
        ],
    },

    footer: {
        row1: {
            title: '相关网站',
            list: [
                { url: 'http://www.hbidding.com', name: '惠招标' },
                { url: 'http://www.hgchzx.com', name: '惠咨询' },
                { url: 'http://www.bhtong.cn', name: '保函通工程' },
            ],
        },
        row2: {
            title: '联系我们',
            list: [
                '联系电话：400-780-9998',
                '邮箱：hb@zhbykj.com',
                '地址：河北省石家庄市桥西区中山东路126号凯嘉大厦10楼',
            ],
        },

        company: '河北中惠博裕科技有限公司',
        companyUrl: 'http://www.zhbykj.com/',
        ICP: '冀ICP备14012003号-14',
        ICPUrl: 'https://beian.miit.gov.cn/',
        copyright: '冀公网安备 13010402001763号',
        copyrightUrl: 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=13010402001763',

        QRCodeList: [
            {
                url: '/images/hzc/qrcode.jpg',
                name: '惠智采微信公众号',
            },
        ],
    },
    //关于我们
    about: {
        qyjs: {
            showLeftVideo: true,
            img1: '/images/about/video_bg.png',
            img2: '/images/about/icon-play.png',
            videoUrl: 'http://www.zhbykj.com/movie.mp4',

            title: '中惠科技',
            rightList: [
                '中惠科技既有在工程建设领域耕耘20余年的行业精英,又有专注互联网发展的技术英才，多年来通过对建设方、咨询机构、造价机构、招标机构需求的分析研究，逐步形成了“惠系列”产品，实现对工程建设领域和政府的信息化产品与服务。',
                '通过打造基于工程领域大数据、人工智能、装配式建筑、移动化工程管理的“领先的工程建设SAAS服务提供商”，以工程建设SAAS服务平台为定位，专注于面向投资人、项目建设单位、工程咨询机构、政府及工程行业人员等客户提供完整的工程技术信息化解决方案；逐步实现360度解决方案覆盖能力，形成基于云端（Web/App）和工程大数据汇集提供更好的用户体验，在工程细分领域打造一个核心技术领先、客户黏性高、团队能力强、竞争优势明显的行业标杆，探索可重复、可扩展、可盈利的为客户提供全方位的、平台化的“互联网+”工程建设服务模式。',
            ],
        },
        // 荣誉资质
        ryzz: [
            '/images/about/h_01.png',
            '/images/about/h_02.png',
            '/images/about/h_03.png',
            '/images/about/h_04.jpg',
            '/images/about/h_05.jpg',
            '/images/about/h_06.jpg',
            '/images/about/h_07.jpg',
        ],
        //企业风采
        qyfc: [
            '/images/about/s_01.png',
            '/images/about/s_02.png',
            '/images/about/s_03.png',
            '/images/about/s_04.png',
            '/images/about/s_05.png',
            '/images/about/s_06.png',
        ],

        //联系我们
        lxwm: {
            mobile: "电话: 400-780-9998 (工作时间: 8:00-17:30)",
            address: '地址: 河北省石家庄市中山东路126号凯嘉大厦10层',
            mapPosition: {
                lng: 114.511191, 
                lat: 38.048417,
            },
        },

        //相关下载
        xgxz: [
            {
                title: "投标文件制作工具",
                urlname: "http://www.hbidding.com/zbdownloadtool/Bid.zip",
                infoa: "投标单位"
            },
            {
                title: "电子招投标数字证书助手",
                urlname: "http://helper.pasiatec.com/client/HEBCA-helper-ztb.zip",
                infoa: null
            },
            {
                title: "惠招标签章工具",
                urlname: "http://www.hbidding.com/zbdownloadtool/CaSeal.zip",
                infoa: null
            },
            {
                title: "IE11下载地址",
                urlname: "https://www.microsoft.com/zh-cn/download/details.aspx?id=40901",
                infoa: "投标单位；代理机构"
            },
            {
                title: "招标文件制作工具",
                urlname: "http://www.hbidding.com/zbdownloadtool/Tender.zip",
                infoa: "代理机构"
            },
            {
                title: "CA办理及绑定说明",
                urlname: "http://www.hbidding.com/zbdownloadtool/cahelp.pdf",
                infoa: "投标单位；代理机构"
            },
            {
                title: "向日葵远程工具",
                urlname: "https://sunlogin.oray.com/download?categ=personal",
                infoa: null
            },
            {
                title: "河北腾翔电子签章客户端",
                urlname: "http://www.hbidding.com/zbdownloadtool/河北腾翔电子签章客户端.zip",
                infoa: null
            },
            {
                title: "设置惠招标可信任站点",
                urlname: "http://www.hbidding.com/upload/15718974688931.zip",
                infoa: null
            },
            {
                title: "CA在线办理",
                urlname: "http://hebcaonline.hebca.com:9001/Hebca/certbussconduct/entry.action?onlineType=4&projectType=zbrhah&cztype=1",
                infoa: null
            },
            {
                title: "谷歌下载地址",
                urlname: "https://www.google.cn/chrome/",
                infoa: "投标单位；代理机构"
            },
            {
                title: "省公共资源认证ca",
                urlname: "http://publicservice.hebpr.cn:8181/#",
                infoa: null
            }
        ],

    },

    
    // 侧边栏
    onlineServe: [
        {
            isPopover: false,
            disabled: false,     //是否 禁用弹窗
            imgUrl: '/images/hzc/consult/1.png',
            text: '电话咨询',
            popoverUrl: '',
            itemCilck: '',
            width: "220"
        },
        {
            isPopover: false,
            disabled: true,
            imgUrl: '/images/hzc/consult/2.png',
            text: '在线咨询',
            popoverUrl: '',
            itemCilck: '',
            width: "220"
        },
        {
            isPopover: false,
            disabled: true,
            imgUrl: '/images/hzc/consult/3.png',
            text: '测试使用',
            popoverUrl: '',
            itemCilck: '',
            width: "220"
        },
        {
            isPopover: false,
            disabled: true,
            imgUrl: '/images/hzc/consult/4.png',
            text: '微信咨询',
            popoverUrl: '',
            itemCilck: '',
            width: "220"
        },
    ],
};